import { Link, useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'

// Mirrors apps/mobile/app/(auth)/privacy.tsx. Same copy.

export function PrivacyPage() {
  const navigate = useNavigate()
  return (
    <div className="min-h-full bg-navy text-white">
      <div className="px-4 pt-8 pb-4 flex items-center justify-between max-w-3xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-gold p-1" aria-label="Back">
          <ChevronLeft size={24} />
        </button>
        <h1 className="text-gold text-xl font-extrabold">jnati</h1>
        <div className="w-8" />
      </div>
      <div className="max-w-3xl mx-auto px-6 pb-12">
        <h2 className="text-gold text-2xl font-extrabold text-center mt-4 mb-5">Privacy Policy</h2>

        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          This Privacy Policy explains how Jnati collects, uses, shares, and protects your
          information when you use our platform.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">1. Information We Collect</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          We collect the following information:<br />
          • Personal details (e.g., name, phone number, date of birth)<br />
          • Account information (e.g., login provider, relatives data)<br />
          • Photos and media you upload
        </p>

        <h3 className="text-gold text-base font-bold mt-6">2. How We Use Your Data</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          We use your data to:<br />
          • Enable family mapping and relationship building<br />
          • Allow you to share media with your network<br />
          • Personalize your experience and suggest relatives
        </p>

        <h3 className="text-gold text-base font-bold mt-6">3. Data Sharing</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          We never sell your data. We only share your information:<br />
          • With other users you connect with (e.g., profile photo, name)<br />
          • When legally required (e.g., court orders)
        </p>

        <h3 className="text-gold text-base font-bold mt-6">4. Data Security</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          Your data is stored securely. We use encryption, authentication, and other safeguards
          to protect it.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">5. Your Rights</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          You may request to:<br />
          • View or update your profile information<br />
          • Delete your account and data at any time<br />
          To request data changes, please email: support@jnati.com
        </p>

        <h3 className="text-gold text-base font-bold mt-6">6. Updates to this Policy</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          We may update this Privacy Policy as needed. Major changes will be notified via the app.
        </p>

        <div className="text-center mt-10">
          <Link to="/login" className="text-gold underline text-[15px]">← Back to Login</Link>
        </div>
      </div>
    </div>
  )
}
